import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import {
  BaseOption,
  Product,
  RoutingService,
  TranslatePipe,
  VariantOptionQualifier,
  VariantQualifier,
} from '@spartacus/core';
import { MediaComponent } from '@spartacus/storefront';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { RemoveImageTitleAttrDirective } from '../../../../../shared/remove-title-attr.directive';

@Component({
  selector: 'app-variant-color-selector',
  templateUrl: './variant-color-selector.component.html',
  styleUrls: ['./variant-color-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, MediaComponent, RemoveImageTitleAttrDirective, MatTooltip, TranslatePipe],
})
export class VariantColorSelectorComponent {
  businessType: string;
  constructor(private routingService: RoutingService, private currentBusinesstype: CurrentBusinessType) {
    this.businessType = this.currentBusinesstype.getBusinessType();
  }

  @Input()
  product: Product;

  @Input()
  variants: BaseOption[];

  changeColor(code: string, name: string): void {
    if (code) {
      this.routingService.go({
        cxRoute: 'product',
        params: { code, name },
      });
    }
    return null;
  }
  getVariantOptionValue(qualifiers: VariantOptionQualifier[]) {
    const obj = qualifiers.find((q) => q.qualifier === VariantQualifier.COLOR);
    return obj ? obj.value : '';
  }
}
